import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// English
import commonEn from './locales/en/common.json';
import authEn from './locales/en/auth.json';
import onboardingEn from './locales/en/onboarding.json';
import clipsEn from './locales/en/clips.json';
import scheduleEn from './locales/en/schedule.json';
import settingsEn from './locales/en/settings.json';
import upgradeEn from './locales/en/upgrade.json';
import pagesEn from './locales/en/pages.json';
import notificationsEn from './locales/en/notifications.json';
import paywallEn from './locales/en/paywall.json';

// 中文正體 (Traditional Chinese)
import commonZhTW from './locales/zh-TW/common.json';
import authZhTW from './locales/zh-TW/auth.json';
import onboardingZhTW from './locales/zh-TW/onboarding.json';
import clipsZhTW from './locales/zh-TW/clips.json';
import scheduleZhTW from './locales/zh-TW/schedule.json';
import settingsZhTW from './locales/zh-TW/settings.json';
import upgradeZhTW from './locales/zh-TW/upgrade.json';
import pagesZhTW from './locales/zh-TW/pages.json';
import notificationsZhTW from './locales/zh-TW/notifications.json';
import paywallZhTW from './locales/zh-TW/paywall.json';

// 中文简体 (Simplified Chinese)
import commonZhCN from './locales/zh-CN/common.json';
import authZhCN from './locales/zh-CN/auth.json';
import onboardingZhCN from './locales/zh-CN/onboarding.json';
import clipsZhCN from './locales/zh-CN/clips.json';
import scheduleZhCN from './locales/zh-CN/schedule.json';
import settingsZhCN from './locales/zh-CN/settings.json';
import upgradeZhCN from './locales/zh-CN/upgrade.json';
import pagesZhCN from './locales/zh-CN/pages.json';
import notificationsZhCN from './locales/zh-CN/notifications.json';
import paywallZhCN from './locales/zh-CN/paywall.json';

// 日本語 (Japanese)
import commonJa from './locales/ja/common.json';
import authJa from './locales/ja/auth.json';
import onboardingJa from './locales/ja/onboarding.json';
import clipsJa from './locales/ja/clips.json';
import scheduleJa from './locales/ja/schedule.json';
import settingsJa from './locales/ja/settings.json';
import upgradeJa from './locales/ja/upgrade.json';
import pagesJa from './locales/ja/pages.json';
import notificationsJa from './locales/ja/notifications.json';
import paywallJa from './locales/ja/paywall.json';

// 한국어 (Korean)
import commonKo from './locales/ko/common.json';
import authKo from './locales/ko/auth.json';
import onboardingKo from './locales/ko/onboarding.json';
import clipsKo from './locales/ko/clips.json';
import scheduleKo from './locales/ko/schedule.json';
import settingsKo from './locales/ko/settings.json';
import upgradeKo from './locales/ko/upgrade.json';
import pagesKo from './locales/ko/pages.json';
import notificationsKo from './locales/ko/notifications.json';
import paywallKo from './locales/ko/paywall.json';

// Deutsch (German)
import commonDe from './locales/de/common.json';
import authDe from './locales/de/auth.json';
import onboardingDe from './locales/de/onboarding.json';
import clipsDe from './locales/de/clips.json';
import scheduleDe from './locales/de/schedule.json';
import settingsDe from './locales/de/settings.json';
import upgradeDe from './locales/de/upgrade.json';
import pagesDe from './locales/de/pages.json';
import notificationsDe from './locales/de/notifications.json';
import paywallDe from './locales/de/paywall.json';

// Español (Spanish)
import commonEs from './locales/es/common.json';
import authEs from './locales/es/auth.json';
import onboardingEs from './locales/es/onboarding.json';
import clipsEs from './locales/es/clips.json';
import scheduleEs from './locales/es/schedule.json';
import settingsEs from './locales/es/settings.json';
import upgradeEs from './locales/es/upgrade.json';
import pagesEs from './locales/es/pages.json';
import notificationsEs from './locales/es/notifications.json';
import paywallEs from './locales/es/paywall.json';

// Français (French)
import commonFr from './locales/fr/common.json';
import authFr from './locales/fr/auth.json';
import onboardingFr from './locales/fr/onboarding.json';
import clipsFr from './locales/fr/clips.json';
import scheduleFr from './locales/fr/schedule.json';
import settingsFr from './locales/fr/settings.json';
import upgradeFr from './locales/fr/upgrade.json';
import pagesFr from './locales/fr/pages.json';
import notificationsFr from './locales/fr/notifications.json';
import paywallFr from './locales/fr/paywall.json';

// Indonesia
import commonId from './locales/id/common.json';
import authId from './locales/id/auth.json';
import onboardingId from './locales/id/onboarding.json';
import clipsId from './locales/id/clips.json';
import scheduleId from './locales/id/schedule.json';
import settingsId from './locales/id/settings.json';
import upgradeId from './locales/id/upgrade.json';
import pagesId from './locales/id/pages.json';
import notificationsId from './locales/id/notifications.json';
import paywallId from './locales/id/paywall.json';

// Italiano (Italian)
import commonIt from './locales/it/common.json';
import authIt from './locales/it/auth.json';
import onboardingIt from './locales/it/onboarding.json';
import clipsIt from './locales/it/clips.json';
import scheduleIt from './locales/it/schedule.json';
import settingsIt from './locales/it/settings.json';
import upgradeIt from './locales/it/upgrade.json';
import pagesIt from './locales/it/pages.json';
import notificationsIt from './locales/it/notifications.json';
import paywallIt from './locales/it/paywall.json';

// Русский (Russian)
import commonRu from './locales/ru/common.json';
import authRu from './locales/ru/auth.json';
import onboardingRu from './locales/ru/onboarding.json';
import clipsRu from './locales/ru/clips.json';
import scheduleRu from './locales/ru/schedule.json';
import settingsRu from './locales/ru/settings.json';
import upgradeRu from './locales/ru/upgrade.json';
import pagesRu from './locales/ru/pages.json';
import notificationsRu from './locales/ru/notifications.json';
import paywallRu from './locales/ru/paywall.json';

// Tiếng Việt (Vietnamese)
import commonVi from './locales/vi/common.json';
import authVi from './locales/vi/auth.json';
import onboardingVi from './locales/vi/onboarding.json';
import clipsVi from './locales/vi/clips.json';
import scheduleVi from './locales/vi/schedule.json';
import settingsVi from './locales/vi/settings.json';
import upgradeVi from './locales/vi/upgrade.json';
import pagesVi from './locales/vi/pages.json';
import notificationsVi from './locales/vi/notifications.json';
import paywallVi from './locales/vi/paywall.json';

const ns = ['common', 'auth', 'onboarding', 'clips', 'schedule', 'settings', 'upgrade', 'pages', 'notifications', 'paywall'];

const resources = {
  en: {
    common: commonEn,
    auth: authEn,
    onboarding: onboardingEn,
    clips: clipsEn,
    schedule: scheduleEn,
    settings: settingsEn,
    upgrade: upgradeEn,
    pages: pagesEn,
    notifications: notificationsEn,
    paywall: paywallEn,
  },
  'zh-TW': {
    common: commonZhTW,
    auth: authZhTW,
    onboarding: onboardingZhTW,
    clips: clipsZhTW,
    schedule: scheduleZhTW,
    settings: settingsZhTW,
    upgrade: upgradeZhTW,
    pages: pagesZhTW,
    notifications: notificationsZhTW,
    paywall: paywallZhTW,
  },
  'zh-CN': {
    common: commonZhCN,
    auth: authZhCN,
    onboarding: onboardingZhCN,
    clips: clipsZhCN,
    schedule: scheduleZhCN,
    settings: settingsZhCN,
    upgrade: upgradeZhCN,
    pages: pagesZhCN,
    notifications: notificationsZhCN,
    paywall: paywallZhCN,
  },
  ja: {
    common: commonJa,
    auth: authJa,
    onboarding: onboardingJa,
    clips: clipsJa,
    schedule: scheduleJa,
    settings: settingsJa,
    upgrade: upgradeJa,
    pages: pagesJa,
    notifications: notificationsJa,
    paywall: paywallJa,
  },
  ko: {
    common: commonKo,
    auth: authKo,
    onboarding: onboardingKo,
    clips: clipsKo,
    schedule: scheduleKo,
    settings: settingsKo,
    upgrade: upgradeKo,
    pages: pagesKo,
    notifications: notificationsKo,
    paywall: paywallKo,
  },
  de: {
    common: commonDe,
    auth: authDe,
    onboarding: onboardingDe,
    clips: clipsDe,
    schedule: scheduleDe,
    settings: settingsDe,
    upgrade: upgradeDe,
    pages: pagesDe,
    notifications: notificationsDe,
    paywall: paywallDe,
  },
  es: {
    common: commonEs,
    auth: authEs,
    onboarding: onboardingEs,
    clips: clipsEs,
    schedule: scheduleEs,
    settings: settingsEs,
    upgrade: upgradeEs,
    pages: pagesEs,
    notifications: notificationsEs,
    paywall: paywallEs,
  },
  fr: {
    common: commonFr,
    auth: authFr,
    onboarding: onboardingFr,
    clips: clipsFr,
    schedule: scheduleFr,
    settings: settingsFr,
    upgrade: upgradeFr,
    pages: pagesFr,
    notifications: notificationsFr,
    paywall: paywallFr,
  },
  id: {
    common: commonId,
    auth: authId,
    onboarding: onboardingId,
    clips: clipsId,
    schedule: scheduleId,
    settings: settingsId,
    upgrade: upgradeId,
    pages: pagesId,
    notifications: notificationsId,
    paywall: paywallId,
  },
  it: {
    common: commonIt,
    auth: authIt,
    onboarding: onboardingIt,
    clips: clipsIt,
    schedule: scheduleIt,
    settings: settingsIt,
    upgrade: upgradeIt,
    pages: pagesIt,
    notifications: notificationsIt,
    paywall: paywallIt,
  },
  ru: {
    common: commonRu,
    auth: authRu,
    onboarding: onboardingRu,
    clips: clipsRu,
    schedule: scheduleRu,
    settings: settingsRu,
    upgrade: upgradeRu,
    pages: pagesRu,
    notifications: notificationsRu,
    paywall: paywallRu,
  },
  vi: {
    common: commonVi,
    auth: authVi,
    onboarding: onboardingVi,
    clips: clipsVi,
    schedule: scheduleVi,
    settings: settingsVi,
    upgrade: upgradeVi,
    pages: pagesVi,
    notifications: notificationsVi,
    paywall: paywallVi,
  },
};

export const SUPPORTED_LANGUAGES = [
  { code: 'en', label: 'English' },
  { code: 'zh-TW', label: '中文正體' },
  { code: 'zh-CN', label: '中文简体' },
  { code: 'ja', label: '日本語' },
  { code: 'ko', label: '한국어' },
  { code: 'de', label: 'Deutsch' },
  { code: 'es', label: 'Español' },
  { code: 'fr', label: 'Français' },
  { code: 'id', label: 'Indonesia' },
  { code: 'it', label: 'Italiano' },
  { code: 'ru', label: 'Русский' },
  { code: 'vi', label: 'Tiếng Việt' },
];

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    defaultNS: 'common',
    ns,
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'clipbait_lang',
      caches: ['localStorage'],
    },
  });

i18n.on('languageChanged', (lng) => {
  document.documentElement.setAttribute('lang', lng);
});

export default i18n;
